import { render } from "./IstcDesktop.vue?vue&type=template&id=59393c06"
import script from "./IstcDesktop.vue?vue&type=script&lang=js"
export * from "./IstcDesktop.vue?vue&type=script&lang=js"

import "./IstcDesktop.vue?vue&type=style&index=0&id=59393c06&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__